import type { ReactNode } from "react";

interface EntityListPaneHeaderProps {
  title: ReactNode;
  children?: ReactNode;
  className?: string;
  hideTitle?: boolean;
}

export function EntityListPaneHeader({
  title,
  children,
  className,
  hideTitle = false,
}: EntityListPaneHeaderProps) {
  return (
    <div className={`p-3 border-b border-sidebar-border ${className ?? ""}`.trim()}>
      {!hideTitle ? <h2 className="text-sm font-semibold">{title}</h2> : null}
      {children}
    </div>
  );
}

